export const AUTO_ACTIONS_RESOURCE_URL = 'findings-policies';
export const AUTO_ACTION_PREVIEW_URL = 'findings/policy-preview';

export const AUTO_ACTIONS_PAGE_TABLE_ID = 'AUTO_ACTIONS_PAGE_TABLE_ID';
